<template>
  <div class="d-flex">
    <div class="container__flag-cards">
      <div
        v-for="index in 2"
        :key="`flagCard__${items[index - 1]}--${index - 1}`"
      >
        <country-flag
          v-if="items[index - 1]"
          :country="items[index - 1]"
          class="flag"
          :class="{
            couple: couple,
          }"
        />
      </div>
    </div>
    <small
      v-if="items.length > 2"
      class="font-weight-regular align-self-center ml-1"
      :class="{ 'neutral--text text--lighten-1': !$vuetify.theme.dark }"
      >+2</small
    >
  </div>
</template>

<script>
import CountryFlag from 'vue-country-flag'

export default {
  name: 'FlagCards',
  components: { CountryFlag },
  props: {
    items: {
      type: Array,
      required: true,
    },
    couple: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
small {
  font-size: 10px;
  white-space: nowrap;
}

.container__flag-cards {
  width: 23px;
  height: 21px;
  :first-child {
    z-index: 2;
    position: absolute;
    left: 1px;
  }

  :last-child {
    position: absolute;
    left: 1px;
    top: 4px;
  }

  :first-child:last-child {
    top: 2px;
    left: 1px;
  }
}

.flag {
  border-radius: 4px;
  margin: -11px 0 0 -16px !important;
  transform: scale(0.44) !important;
  -ms-transform: scale(0.44) !important;
  -webkit-transform: scale(0.44) !important;
  -moz-transform: scale(0.44) !important;

  &.couple {
    margin-left: 5px !important;
  }
}
</style>
